import { createBlock, defineComponent, openBlock, unref } from "vue";
import { ScalarCodeBlock } from "@scalar/components/code-block";
//#region src/components/ResponseBody/ResponseBodyRaw.vue?vue&type=script&setup=true&lang.ts
var ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ResponseBodyRaw",
	props: {
		content: {},
		language: {}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(ScalarCodeBlock), {
				class: "codeBlock",
				content: props.content,
				lang: __props.language
			}, null, 8, ["content", "lang"]);
		};
	}
});
//#endregion
export { ResponseBodyRaw_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ResponseBodyRaw.vue_vue_type_script_setup_true_lang.js.map